import { FC, useEffect, useState } from "react";
import dayjs from "dayjs";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { Media, MediaLeft, MediaBody } from "@ht/components";
import { useAppDispatch } from "../../../app/hooks";
import { activeChatAgentRoom } from "../../../app/chatAgent/chatAgentSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { IIncomingRoom } from "../../../app/chatAgent/types";
import getInitials from "../../../utils/getInitials";
interface IProps {
    path: string;
    user: IIncomingRoom;
    isSelected: boolean;
}

const Chat: FC<IProps> = ({ path, user, isSelected }) => {
    const chatCallback = useSelector((state: RootState) => state.chatagent.status);
    const { layoutType } = useSelector((state: RootState) => state.chatagent);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isTyping, setIsTyping] = useState(false);

    const navigationHandler = () => {
        const activeChatObj = {
            userName: user.userName,
            roomId: user.roomId,
            sessionId: user.sessionId
        }
        if (layoutType == "PAGE") navigate(path);

        localStorage.setItem("activeChatAgentRoom", JSON.stringify(activeChatObj));
        dispatch(activeChatAgentRoom(activeChatObj));
    };

    useEffect(() => {
        if (chatCallback.status == "TYPING" && chatCallback.userName == user.userName) {
            setIsTyping(true);
            const timeout = setTimeout(() => {
                setIsTyping(false);
            }, 500);
            return () => clearTimeout(timeout);
        } else if (chatCallback.status == "SENT") {
            setIsTyping(false);
        }
    }, [chatCallback]);

    const getLatestMessage = () => {
        const result = (<> {isTyping ? "Typing..." : user.latestMessage} </>);
        return result;
    }

    const getLatestMessageTime = (time: Date) => {
        let result = dayjs(time).format("MMM DD");
        const messageDate = dayjs(time).format("YYYY-MM-DD");
        const dateNow = dayjs().format("YYYY-MM-DD");
        const yesterday = dayjs().subtract(1, 'day').format("YYYY-MM-DD");

        if (messageDate == dateNow) {
            result = dayjs(time).format("HH:mm");
        } else if (messageDate == yesterday) {
            result = 'Yesterday';
        }

        return result;
    }
    const redNotif = () => {
        let result = (<></>);
        if (user.unreadMessageCount > 0)
            result = (<div className="rounded-[4px] bg-red-900 w-5 h-5 self-end text-center">
                <span className=" text-[10px] text-white" >{user.unreadMessageCount > 999 ? 999 : user.unreadMessageCount}</span>
            </div>);
        return result;
    }
    return (
        <div className="my-1 outline-none">
            <button onClick={navigationHandler} className="w-full" tabIndex={0}>
                <Media
                    className={clsx(
                        "relative px-5 py-[10px] transition-colors border-t border-t-gray-100 first:border-t-0 overflow-hidden",
                        "before:absolute before:content-[''] before:top-0 before:bottom-0 before:-left-px before:w-0.5  before:opacity-0 before:transition-opacity hover:before:opacity-100",
                        isSelected ? "bg-gray-200 rounded-md mx-2 px-[12px]" : "",
                        "items-center hover:bg-gray-200 rounded-md mx-2 px-[12px]",
                        "max-h-[54px] cursor-pointer"
                    )}
                >
                    <MediaLeft className="relative min-w-9 ">
                        <div className="bg-gray-300 rounded-full w-9 h-9 flex items-center justify-center text-base">
                            <span>{getInitials(user.fullName)}</span>
                        </div>

                    </MediaLeft>
                    <MediaBody className="ml-3 flex flex-col">
                        <div className="flex justify-between">
                            <div className="mr-2 xxsToXs:max-w-[120px] xsToSm:max-w-[250px] sm:max-w-[450px] md:max-w-[650px] lg:max-w-[180px]">
                                <div className="flex-1 text-md text-gray-700 font-medium mb-[2px] truncate">{user.fullName} </div>
                                <div className="text-base text-gray-400 mb-1.5 truncate">{getLatestMessage()}</div>
                            </div>

                            <div className="flex flex-col">
                                <div className="mb-2">
                                    {user.latestMessageTime && (
                                        <span className="text-[10px] text-gray-400 block font-semibold">
                                            {getLatestMessageTime(user.latestMessageTime)}
                                        </span>
                                    )}
                                </div>
                                {redNotif()}
                            </div>
                        </div>
                    </MediaBody>
                </Media>
            </button >
        </div>
    );
};

export default Chat;
